import { createSelector } from 'reselect';
import {
    get, has,
} from 'lodash';
import { buildReservationSelector } from './reservations.selector';
import { buildRequestSelector } from './requests.selector';
/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => get(state, 'app.database.memberReports', {});
const getMetaEntities = (state) => get(state, 'app.metaDatabase.memberReports', {});
const getReservationSelector = (state) => (reservationId) => buildReservationSelector()(state, reservationId);
const getRequestSelector = (state) => (requestId) => buildRequestSelector()(state, requestId);
/**
 * Selector Builders
 */
export const buildMetaReportsSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildReportsSelector = () => createSelector([
    getEntityId,
    getEntities,
    getReservationSelector,
    getRequestSelector,
], (entityId, entities, reservationSelector, requestSelector) =>
{
    if (has(entities, entityId))
    {
        const report = entities[entityId];

        return {
            ...report,
            reservations: report.reservations ? report.reservations.map((reservation) => reservationSelector(reservation)) : [],
            requests: report.requests ? report.requests.map((request) => requestSelector(request)) : [],
        };
    }

    return {};
});
